var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('confirm_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("confirm_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('confirm_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("confirm_page.form_desc")) + " ")]) : _vm._e(), _vm.isNewWorker ? _c('div', [_c('div', {
    staticClass: "field"
  }, [_vm._m(0), _c('div', {
    staticClass: "field__select-group"
  }, [_c('SharedSelect', {
    attrs: {
      "options": _vm.partner_city_options,
      "hasBorder": false,
      "disabled": _vm.isBound,
      "placeholder": "請先選擇區域。"
    },
    model: {
      value: _vm.form.partner_city,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partner_city", $$v);
      },
      expression: "form.partner_city"
    }
  })], 1)]), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "d-flex align-items-center page__title"
  }, [_c('div', {
    staticClass: "text-left col-6 field--required"
  }, [_vm._v("服務醫院")]), _c('div', {
    staticClass: "col-6 d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.keyword,
      expression: "keyword"
    }],
    staticClass: "field__input",
    attrs: {
      "type": "text",
      "placeholder": "可輸入醫院名稱搜尋"
    },
    domProps: {
      "value": _vm.keyword
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value;
      }
    }
  }), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm.notFound ? _c('div', {
    staticClass: "error-msg text-right"
  }, [_vm._v("查無資料")]) : _vm._e(), _c('div', {
    staticClass: "d-flex row  align-items-center"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.create_partner,
      expression: "form.create_partner"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.form.create_partner, false)
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.form, "create_partner", false);
      }
    }
  }), _vm._v(" 選擇醫院 ")]), _c('SharedSelect', {
    ref: "selectPartnerElement",
    staticClass: "col-9",
    attrs: {
      "options": _vm.partner_options,
      "hasBorder": false,
      "disabled": _vm.isBound || !_vm.form.partner_city || _vm.form.create_partner || _vm.loading
    },
    model: {
      value: _vm.form.partner_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partner_id", $$v);
      },
      expression: "form.partner_id"
    }
  })], 1), _c('div', {
    staticClass: "d-flex row mt-3 align-items-center"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.create_partner,
      expression: "form.create_partner"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.form.create_partner, true)
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.form, "create_partner", true);
      }
    }
  }), _vm._v(" 其他 ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.partner_name,
      expression: "form.partner_name"
    }],
    staticClass: "field__input col-9",
    attrs: {
      "hasBorder": false,
      "disabled": !_vm.form.create_partner
    },
    domProps: {
      "value": _vm.form.partner_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "partner_name", $event.target.value);
      }
    }
  })]), _vm.createPartnerError ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]), _vm._l(_vm.fields.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (field, index) {
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [field.type === 'select' && field.matched_key ? _c('div', [_c('div', [_c('div', {
      staticClass: "page__title text-left",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "d-flex row align-items-center"
    }, [field.can_create ? _c('div', {
      staticClass: "col-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: field.is_selected,
        expression: "field.is_selected"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(field.is_selected, false)
      },
      on: {
        "change": function change($event) {
          return _vm.$set(field, "is_selected", false);
        }
      }
    }), _vm._v(" 選擇" + _vm._s(field.title) + " ")]) : _vm._e(), _c('SharedSelect', {
      class: field.can_create ? 'col-9' : 'col-12',
      attrs: {
        "options": field.options,
        "hasBorder": false,
        "placeholder": field.placeholder,
        "disabled": field.disabled
      },
      model: {
        value: _vm.form[field.field_key],
        callback: function callback($$v) {
          _vm.$set(_vm.form, field.field_key, $$v);
        },
        expression: "form[field.field_key]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e()], 1), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e(), field.can_create ? _c('div', {
      staticClass: "d-flex row mt-3 align-items-center"
    }, [_c('div', {
      staticClass: "col-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: field.is_selected,
        expression: "field.is_selected"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(field.is_selected, true)
      },
      on: {
        "change": function change($event) {
          return _vm.$set(field, "is_selected", true);
        }
      }
    }), _vm._v(" 其他 ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.field_key],
        expression: "form[field.field_key]"
      }],
      staticClass: "field__input col-9",
      attrs: {
        "hasBorder": false,
        "disabled": !field.is_selected
      },
      domProps: {
        "value": _vm.form[field.field_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.field_key, $event.target.value);
        }
      }
    })]) : _vm._e()])]) : field.type === 'text' && field.matched_key ? _c('div', [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "page__title text-left",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(" " + _vm._s(field.title) + " ")])]), _c('div', {
      staticClass: "field__select-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.field_key],
        expression: "form[field.field_key]"
      }],
      staticClass: "field__input flex-fill",
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "placeholder": field.placeholder,
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form[field.field_key]
      },
      on: {
        "keypress": function keypress($event) {
          return _vm.v$.$touch();
        },
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.field_key, $event.target.value);
        }
      }
    })]), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(" " + _vm._s(field.memo) + " ")]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : field.type === 'email' && field.matched_key ? _c('div', [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "page__title text-left",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(" " + _vm._s(field.title) + " ")])]), _c('div', {
      staticClass: "field__select-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form[field.field_key],
        expression: "form[field.field_key]"
      }],
      staticClass: "field__input flex-fill",
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "placeholder": field.placeholder,
        "disabled": field.disabled,
        "type": "email"
      },
      domProps: {
        "value": _vm.form[field.field_key]
      },
      on: {
        "keypress": function keypress($event) {
          return _vm.v$.$touch();
        },
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, field.field_key, $event.target.value);
        }
      }
    })]), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(" " + _vm._s(field.memo) + " ")]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()]) : _vm._e()]);
  })], 2) : _c('div', [_c('div', {
    staticClass: "field"
  }, [_vm._m(1), _c('div', {
    staticClass: "field__select-group"
  }, [_c('SharedSelect', {
    attrs: {
      "options": _vm.partner_options,
      "hasBorder": false
    },
    model: {
      value: _vm.form.partner_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partner_id", $$v);
      },
      expression: "form.partner_id"
    }
  })], 1)]), _c('div', {
    staticClass: "field"
  }, [_vm._m(2), _c('div', {
    staticClass: "field__select-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.job_specialty,
      expression: "form.job_specialty"
    }],
    staticClass: "field__input flex-fill",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.form.job_specialty
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "job_specialty", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_vm._m(3), _c('div', {
    staticClass: "field__select-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.staff_name,
      expression: "form.staff_name"
    }],
    staticClass: "field__input flex-fill",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.form.staff_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "staff_name", $event.target.value);
      }
    }
  })])])])]), _c('div', {
    staticClass: "reminder",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('confirm_page.reminder'))
    }
  }), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("confirm_page.button_text")) + " ")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page__title text-left field--required"
  }, [_vm._v("區域")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page__title text-left"
  }, [_vm._v("服務醫院")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page__title text-left"
  }, [_vm._v("服務科室")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page__title text-left"
  }, [_vm._v("負責業務")])]);
}]

export { render, staticRenderFns }